import { render, staticRenderFns } from "./MasterSide.vue?vue&type=template&id=1943c811&scoped=true"
import script from "./MasterSide.vue?vue&type=script&lang=js"
export * from "./MasterSide.vue?vue&type=script&lang=js"
import style0 from "./MasterSide.vue?vue&type=style&index=0&id=1943c811&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1943c811",
  null
  
)

export default component.exports